import { useCallback, useEffect, useRef, useState } from 'react';

import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import { EDropdownPlacement } from '@aquariuxfintech/aqx-trader-react-ui/dropdown';
import { EUIInputVariant } from '@aquariuxfintech/aqx-trader-react-ui/input';
import UISelectPicker from '@aquariuxfintech/aqx-trader-react-ui/select-picker';

import { EDataTestId } from '@aqx-core/common/data-test-id/types';
import { appLanguageManager } from '@aqx-core/common/i18n';
import { TAppLanguageISOCountryCode } from '@aqx-core/common/i18n/types';
import { useCompanyLanguageOptions } from '@aqx-core/common/services/company';

interface IUILanguageSelectPickerProps {}

const UILanguageSelectPicker: FCC<IUILanguageSelectPickerProps> = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const languageOptions = useCompanyLanguageOptions();
  const languageOptionWithTestId = languageOptions.map((option) => ({
    ...option,
    dataTestId: EDataTestId.LANGUAGE_OPTION
  }));

  const {
    i18n: { language }
  } = useTranslation();

  const [selectedValue, setSelectedValue] = useState<TAppLanguageISOCountryCode>(
    language as TAppLanguageISOCountryCode
  );

  useEffect(() => {
    setSelectedValue(language as TAppLanguageISOCountryCode);
  }, [language]);

  const handleSelectLanguage = useCallback((value: TAppLanguageISOCountryCode) => {
    setSelectedValue(value);
    appLanguageManager.changeLanguage({
      language: value
    });
  }, []);

  return (
    <StyledUILanguageSelectPickerContainer ref={containerRef} data-testid={EDataTestId.LANGUAGE_DROPDOWN}>
      <UISelectPicker
        options={languageOptionWithTestId}
        onSelect={handleSelectLanguage}
        selectedValue={selectedValue}
        dropdownPlacement={EDropdownPlacement.BOTTOM_END}
        dropdownWidth="140px"
        selectorProps={{
          variant: EUIInputVariant.BASE_SELECT
        }}
      />
    </StyledUILanguageSelectPickerContainer>
  );
};

export default UILanguageSelectPicker;

const StyledUILanguageSelectPickerContainer = styled.div``;
